// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__dECcZ","title":"BackImages_title__3j6ju","images":"BackImages_images__K2FN0"};